import * as React from "react";
const SvgWindowMinimize = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 12.25H15V13.75H1V12.25Z", fill: "currentColor" }));
export default SvgWindowMinimize;
